'use client'; // Error components must be Client Components

import style from './error.module.css';

export default function NotFound() {
    return <body><iframe src={`/404`} className={style.iframe} /></body>;
}
